import axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

// Utility function to clear cookies
const clearCookies = () => {
  const cookieOptions = { path: '/', sameSite: 'None', secure: true };
  ['user', 'access', 'refresh', 'csrftoken'].forEach((cookie) =>
    Cookies.remove(cookie, cookieOptions)
  );
};

// Define apiUrl from environment variables
const apiUrl = process.env.REACT_APP_API_URL;

// Create an Axios instance
const api = axios.create({
  baseURL: `${apiUrl}`, // Use the apiUrl for the base URL
  withCredentials: true, // Ensure cookies are sent with requests
  // headers: {
  //   'X-CSRFToken': getCSRFToken(), // Include CSRF token from cookies
  // },
});

// function getCSRFToken() {
//   const csrfCookie = document.cookie
//     .split('; ')
//     .find(row => row.startsWith('csrftoken='));
//   return csrfCookie ? csrfCookie.split('=')[1] : null;
// }

// Add a response interceptor to handle expired tokens
let isLoggingOut = false; // Track if logout is already in progress

api.interceptors.response.use(
  (response) => response, // Return the response if no errors
  async (error) => {
    const originalRequest = error.config;

    // Check if the error is due to an expired access token (401) and the request has not been retried
    if (error.response.status === 401 && !originalRequest._retry && !isLoggingOut) {
      originalRequest._retry = true;

      try {
        // Attempt to refresh the token
        const refreshResponse = await axios.post(
          `${apiUrl}api/v1/auth/token/refresh/`,
          {},
          { withCredentials: true }
        );

        // If the refresh token is valid, retry the original request
        if (refreshResponse.status === 200) {
          return api(originalRequest); // Retry the original request with the new token
        }
      } catch (refreshError) {
        if (!isLoggingOut) {
          isLoggingOut = true;

          // Clear cookies and notify the user
          clearCookies();
          toast.error('Session expired. You have been logged out.');

          // Delay redirect slightly to allow the toast message to appear
          setTimeout(() => {
            window.location.href = '/login'; // Adjust the login path if necessary
            isLoggingOut = false; // Reset the flag
          }, 1000);

          return Promise.reject(refreshError); // Return the error for handling
        }
      }
    }

    return Promise.reject(error); // Reject the error if it's not related to token expiration
  }
);

export default api;

// // this is the most recent i used that worked well except it did not give us a toast message upon logout due to expired refresh token
// import axios from 'axios';
// import Cookies from 'js-cookie';
// import { toast } from 'react-toastify';

// // Define apiUrl from environment variables
// const apiUrl = process.env.REACT_APP_API_URL;

// // Create an Axios instance
// const api = axios.create({
//   // baseURL: 'http://localhost:8000/api/v1/',
//   // baseURL: process.env.REACT_APP_API_URL + '/api/v1/',
//   baseURL: `${apiUrl}`, // Use the apiUrl for the base URL
//   withCredentials: true,  // Ensure cookies are sent with requests
// });

// // Add a response interceptor to handle expired tokens
// api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     // Check if the error is due to an expired access token (401) and the request has not been retried
//     if (error.response.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;

//       try {
//         // Attempt to refresh the token ${apiUrl}
//         // const refreshResponse = await axios.post('http://localhost:8000/api/v1/auth/token/refresh/', {}, { withCredentials: true });
//         // const refreshResponse = await axios.post(`${apiUrl}/api/v1/auth/token/refresh/`, {}, { withCredentials: true });
//         const refreshResponse = await axios.post(
//           `${apiUrl}api/v1/auth/token/refresh/`,
//           {},
//           { withCredentials: true }
//         );

//         // If the refresh token is valid, retry the original request
//         if (refreshResponse.status === 200) {
//           return api(originalRequest); // Retry the original request with the new token
//         }
//       } catch (refreshError) {
//         // If the refresh token is also expired or invalid, handle logout and redirection
//         // Cookies.remove('access');
//         // Cookies.remove('refresh');
//         // Cookies.remove('csrftoken');
//         // Cookies.remove('user');
//         Cookies.remove('user', { path: '/', sameSite: 'None', secure: true });
//         Cookies.remove('access', { path: '/', sameSite: 'None', secure: true  });
//         Cookies.remove('refresh', { path: '/', sameSite: 'None', secure: true  });
//         // Cookies.remove('csrftoken', { sameSite: 'None', secure: true }, { path: '/' });
//         Cookies.remove('csrftoken', { path: '/', sameSite: 'None', secure: true });

//         // Dispatch a logout event for the UI to handle (optional)
//         window.dispatchEvent(new Event('userLoggedOut'));

//         // Show a message to the user
//         toast.error('Session expired. You have been logged out.');

//         // i just added this Delay redirect slightly to allow toast message to appear
//         setTimeout(() => {
//           window.location.href = '/login'; // Adjust the login path if necessary
//         }, 1000); // Delay in milliseconds

//         // Redirect to the login page
//         // window.location.href = '/login'; // Adjust the login path if necessary

//         // Show a message to the user
//         // toast.error('Session expired. You have been logged out.');

//         return Promise.reject(refreshError); // Return the error for handling
//       }
//     }

//     return Promise.reject(error); // Reject the error if it's not related to token expiration
//   }
// );

// export default api;